import { Accordion } from '@bphxd/ds-core-react';
import { Navbar, NavbarBrand } from 'reactstrap'
import { Logo } from '@bphxd/ds-core-react';

const FAQ: React.FC = () => {
  return (
    <>
    <Navbar expand className="navbar-border" sticky="top">
      <div className="d-flex align-items-center">
          <NavbarBrand href={`/`}>
            <Logo className="mx-n3" />
            <span className="ms-5">Digital Twin Companion App</span>
          </NavbarBrand>
        </div>
    </Navbar>
    <div className="container mt-6 mb-4">
      <div className="row">
        <div className="col-md-5">
          <h2 className="display-3 lh-1-375">Frequently asked questions</h2>
        </div>
        <div className="col-md-6 offset-md-1">
          <Accordion defaultOpen="1" size="lg">
            <Accordion.Item>
              <Accordion.Header
                subtitle=""
                targetId="1"
                title="Why am I not able to edit the data?"
              />
              <Accordion.Body accordionId="1">
                <p>
                  If you are not able to edit the data, you have a read-only role. If you need to
                  edit the data, reach out to Joshua Ellison to be added to correct role.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header
                subtitle=""
                targetId="2"
                title="Why is the data from the source system not showing accurately?"
              />
              <Accordion.Body accordionId="2">
                <p>
                  Data from other systems are currently at different refresh rates. They are as
                  follows:
                </p>
                <p>
                  SAP: For event creation, there is a max 48 hour delay from when MO is created to
                  when we may see it in Companion App. If you add a single job, it is realtime, as
                  is the data queried after. If you see a mismatch, please report it using the Leave
                  Feedback.
                </p>
                <p>
                    eCoW: Data is near real-time. ~15 minutes delay.
                </p>
                <p>
                    eMOC: Data is a 24hr refresh.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header subtitle="" targetId="3" title="Why do the links out other products do not work?" />
              <Accordion.Body accordionId="3">
                <p>
                  Please make sure you have correct access in each of these systems to be able to view the data.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header subtitle="" targetId="4" title="Where can I see the list of feedback currently submitted?" />
              <Accordion.Body accordionId="4">
                <p>
                  Current feedback can be found here:
                  </p>
                  <p>
                  <a
                    href='https://digitalfeedback.bpglobal.com/dashboard/_BLEQJVi'
                    target='_blank'
                    rel="noreferrer"
                    >
                        Feedback Hub
                  </a>
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header subtitle="" targetId="5" title="How long before the photos that I upload are viewable in Aize?" />
              <Accordion.Body accordionId="5">
                <p>
                  Photos are refreshed once a day.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header subtitle="" targetId="6" title="What if my question isn't listed here?" />
              <Accordion.Body accordionId="6">
                <p>
                  Please submit it using the Feedback link and attaching a screenshot if helpful. You can also ping Joshua Ellison on Teams.
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
    </>
  );
};

export default FAQ;
